import GuideCard from "./GuideCard";
import { GUIDES } from "../data/guides";

type Props = {
    /** Ordered list of guide slugs to show. Missing slugs are silently
     *  dropped — keeps callers safe when a guide is renamed or removed. */
    slugs: string[];
    heading?: string;
};

// Block of "related guides" cards rendered at the foot of guide and
// tour-template pages. Drives internal linking for SEO and keeps users
// flowing through the content rather than bouncing.
export default function RelatedGuides({ slugs, heading = "Related guides" }: Props) {
    const guides = slugs
        .map((slug) => GUIDES.find((g) => g.slug === slug))
        .filter((g): g is NonNullable<typeof g> => Boolean(g));

    if (guides.length === 0) return null;

    return (
        <section className="gt-related-guides">
            <h2 className="gt-h3 gt-related-guides__heading">{heading}</h2>
            <div className="gt-grid--cards gt-related-guides__grid">
                {guides.map((g) => (
                    <GuideCard
                        key={g.slug}
                        to={`/guides/${g.slug}`}
                        eyebrow={`Guide · ${g.readingTime}`}
                        title={g.title}
                        body={g.summary}
                        image={g.image}
                        icon={g.icon}
                        accentColor={g.accentColor}
                    />
                ))}
            </div>
        </section>
    );
}
